import React, { useState } from 'react';
import { Button, Box,Typography} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export function FileUpload2(){

   // current file to upload into container
   const [fileSelected2, setFileSelected2] = useState(null);
   // UI/form management
   const [uploading2, setUploading2] = useState(false);
   const [inputKey2, setInputKey2] = useState(Math.random().toString(36));

   // the configuration information is fetched from the .env file


  const uploadBlobFile = async (file) => {
    try {
      // Step 1: Ask backend for presigned URL

      const response = await fetch(
        process.env.REACT_APP_UPLOAD_API_URL, 
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fileName: file.name,
            contentType: file.type,
            fileSize: file.size
          }),
        }
      );

      console.log("Response:", response);
      if (!response.ok) {
        throw new Error("Failed to get upload URL");
      }

      const { uploadUrl, objectKey } = await response.json();

      console.log("Presigned URL received:", uploadUrl);

      // Step 2: Upload directly to S3
      const uploadResponse = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
        },
        body: file,
      });

      if (!uploadResponse.ok) {
        throw new Error("Failed to upload file to S3");
      }

      console.log("Upload successful");

      return {
        success: true,
        key: objectKey,
      };

    } catch (error) {
      console.error("Upload error:", error);
      return {
        success: false,
        error: error.message,
      };
    }
  };


  const onFileChange = (event) => {
    // capture file into state
    setFileSelected2(event.target.files[0]);
    console.log(event.target.files[0]);
  };

  const onFileUpload = async () => {
    // prepare UI
    setUploading2(true);

    // *** UPLOAD TO AWS STORAGE ***
    console.log(fileSelected2);
    const resp = await uploadBlobFile(fileSelected2);

    // console log results
    console.log(resp);

    // reset state/form
    setFileSelected2(null);
    setUploading2(false);
    setInputKey2(Math.random().toString(36));
  };

  // display form
  const DisplayForm = () => (
    <Box component="form" 
    onSubmit={onFileUpload} 
    display="flex" 
    flexDirection="column" 
    alignItems="center" 
    p={4}>
  <h1>Upload to AWS S3</h1>
  <h3>using pre-signed URL & API Gateway</h3>
  <Box sx={{ p: 2, textAlign: 'center' }}>
    <input
      type="file"
      key={inputKey2 || ''}
      onChange={onFileChange}
      style={{ display: 'none' }}
      id="file-input"
    />
    <label htmlFor="file-input">
      <Button
        variant="contained"
        color="primary"
        component="span"
        startIcon={<CloudUploadIcon />}
      >
        Choose File
      </Button>
    </label>
    {fileSelected2 && <Typography>{fileSelected2.name}</Typography>}
    <Box sx={{ display: 'none'}}>
      <input type="text" 
      value={fileSelected2==null?'':fileSelected2.name} 
      />
    </Box>
  </Box>
  <Button 
  type="submit"
  color="primary"
  variant="contained"
  disabled={!fileSelected2}       
  sx={{ mt: 3 }}>
    Upload!
  </Button>
</Box>
  );

  return (
    <div>
      <hr />     
      {!uploading2 && DisplayForm()}
      {uploading2 && <div>Uploading</div>}
    </div>
  );
};

